import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import ExportButtons from "@/components/reports/ExportButtons";
import OccupancyBars from "@/components/reports/OccupancyBars";

/** Reporte de Ocupación de agenda por profesional en el periodo elegido. */
export default function OccupancyTab({ period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/occupancy", { params: periodParams(period) })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar Ocupación", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || !data) return <p className="text-center text-muted-foreground py-12">Cargando ocupación...</p>;

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ExportButtons reportKey="occupancy" period={period} />
      </div>
      <div className="bg-white border border-border rounded-xl p-5">
        <OccupancyBars data={data.by_professional} testId={REPORTS.occupancyTable} />
      </div>
    </div>
  );
}
